/* eslint formatjs/no-literal-string-in-jsx: "error" */
import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"

import { UseMutationResult } from "@tanstack/react-query"
import { useToastsWithMutation } from "./useToastsWithMutation"
import { useIntl } from "react-intl"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const queryKey = "UPDATE_BANK_DETAILS"

export default function useUpdateBankDetails(): UseMutationResult {
  const intl = useIntl()

  const getSuccessMessage = (): string => {
    return intl.formatMessage({ defaultMessage: "Bank details have been saved." })
  }
  const request = (args) => client.updateBankDetails(args)

  return useToastsWithMutation({
    request,
    queryKey,
    getSuccessMessage: () => getSuccessMessage()
  })
}
